import { render, staticRenderFns } from "./spinningwheel.vue?vue&type=template&id=28f41acc&scoped=true&"
import script from "./spinningwheel.vue?vue&type=script&lang=js&"
export * from "./spinningwheel.vue?vue&type=script&lang=js&"
import style0 from "./spinningwheel.vue?vue&type=style&index=0&id=28f41acc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f41acc",
  null
  
)

export default component.exports